import { useMutation } from 'react-query';

import { createSFCase } from '@ge/feat-monitor/services';

/**
 * Create a SF case.
 *
 * @returns {{create: Function, isLoading: boolean, isError: boolean, error: String}}
 */

export const useCreateSFCase = ({ onSuccess, onError }) => {
  const {
    mutate: create,
    isLoading,
    isError,
    error,
  } = useMutation((caseId) => createSFCase(caseId), {
    onSuccess: (res) => {
      onSuccess(res?.response?.sfCaseId);
    },
    onError: (error) => {
      onError(error?.response?.data);
    },
  });

  return { create, isLoading, isError, error };
};
